export const NEETO_UI_PRIMARY_500 = "#4558f9";
